/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import { useMutation, useQueryClient } from "@tanstack/react-query";
import { fetcher } from "./fetcher";
import { queryKeys, mutationKeys } from "./queryKeys";

export const useDeletePaymentMethod = (id) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: mutationKeys.deletePaymentMethod(id),
    mutationFn: () => fetcher({ method: "DELETE", url: `/public/payment-methods/item/id/${id}` }),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: queryKeys.paymentMethods.all }),
  });
};
